<template>
  <div>
    <toggle-collapse>
      <DevicesListFilters
      :haseSupportFilter="true"
       @divicesFilterd="divicesFilterd" @merageFilterWithRequest="merageFilterWithRequest" />
    </toggle-collapse>


    <b-form @submit.prevent="getReport" class="">

      <!-- <ToggleCollapse>

      </ToggleCollapse> -->
      <b-card style="position: relative">

        <div v-if="loading" class="loading_page">
          <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
        </div>
        <b-row class="mt-2">
          <b-col cols="4">
            <b-form-group :label="$t('containers')" label-for="vi-containers-id">
              <v-select multiple :close-on-select="false" v-model="request.containers" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{ name: $t('all'), id: 'all' }, ...containers]"
                :reduce="d => d.id" v-on:input="reFilterDevices('containers',request)" />
              <small v-if="errors && ('containers' in errors)" class="text-danger">
                {{ $t(errors['containers'][0]) }}
              </small>
            </b-form-group>
          </b-col>

          <!-- devices  -->
          <b-col cols="4">
            <b-form-group :label="$t('Devices')" label-for="vi-devices-id">
              <v-select multiple :close-on-select="false" v-model="request.devices" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                :getOptionLabel="d => d.name" :options="[{ name: $t('all'), id: 'all' }, ...devices]"
                :reduce="d => d.id" />
              <small v-if="errors && ('devices' in errors)" class="text-danger">
                {{ $t(errors['devices'][0]) }}
              </small>
            </b-form-group>
          </b-col>
          <b-col md="4" sm="4">
            <!-- report range date -->
            <b-form-group :label="$t('Select Start Date To End Date')" label-for="report-date" :state="null">
              <flat-pickr v-model="rangeDate" :state="null" class="form-control" :config="{ ...pickerOptions }"
                placeholder="YYYY-MM-DD" />

              <b-form-invalid-feedback v-if="errors && (('from' in errors) || ('to' in errors))"
                :state="errors && (('from' in errors) || ('to' in errors)) ? false : null">
                {{('from' in errors) ? errors['from'][0] : '' }}
                {{('to' in errors) ? errors['to'][0] : '' }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>




        <b-row class="mt-2">
          <!-- reset and submit -->
          <b-col cols="12">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1">
              {{ $t('Get Report') }}
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-form>


    <div v-if="report_data">
      <DataTable :report_data="report_data" :report_fields="report_fields"
        :filter_included_fields="filter_included_fields" :request="request" :errors="errors" :loading="dataTableloading||loading"
        :getReport="getReport" :total="total" :from="from" :to="to"  :sortData="sortData" />

    </div>

  </div>

</template>

<script>

import {
  BButton, BTable, BFormInvalidFeedback, BCard, BCol, BFormCheckboxGroup,
  BForm, BFormCheckbox, BFormRadioGroup, BFormGroup, BFormInput, BPagination,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BTabs, BTab, BCardText, BLink, BMedia,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { OrbitSpinner } from 'epic-spinners'

import { ref, computed } from '@vue/composition-api'

import {
  createFrame, createjsPDFInstance, createTable
} from '@/share/reports/pdfCommonFunctions'

import Cleave from 'vue-cleave-component'
//import reportForm from '@/app/reports/containerService/reportForm'
import reportForm from '@/app/reports/share/reportForm'
import ReportLogic from '@/app/reports/containerService/logic'
import { ExportDataServices } from '@/share/reports/exportService'
import DevicesListFilters from '../filters/DevicesListFilters.vue'
import FilterLogic from '@/views/reports/filters/filterLogic.js'
import ToggleCollapse from '@/views/ui/toggle-collapse/ToggleCollapse.vue'
// import ReportOptions from '@/views/reports/components/options.js'
import PickerOptions from '@/views/reports/components/options_2.js'
import DataTable from '@/views/reports/data-table/DataTable.vue'


export default {
  name: 'CompactorReport',
  components: {
    BRow, BCard, BFormCheckboxGroup, BTable, BPagination,
    BCol, BFormRadioGroup, BFormInvalidFeedback,
    BAlert, BFormGroup, BFormInput, flatPickr,
    BFormCheckbox, BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BTabs,
    BCardText,
    BTab,
    vSelect,
    OrbitSpinner,
    Cleave,
    BLink,
    BMedia,
    ToggleCollapse, DevicesListFilters,
    DataTable
  },
  directives: { Ripple, },

  setup(props, { root }) {




    const { devices } = FilterLogic()


    const divicesFilterd = (data) => {
      devices.value = data;
    }


    const merageFilterWithRequest = (data) => {

      delete data['type']
      if (data['isSupport'] == "all") {
        delete data['isSupport']
        delete request.value.isSupport
      }

      Object.assign(request.value, data);
    }






    const tableRef = ref(null)
    const { owners, contracts, containers, reFilterDevices } = reportForm()

    const { report_data, request, errors, loading, getReport, getReportForPdf, total, from, to,sortBy,isSortDirDesc,dataTableloading } = ReportLogic()
    const sortData=(data)=>{
      sortBy.value=data.sortBy
      isSortDirDesc.value=data.isSortDirDesc
    }

    const perPageOptions = [5, 10, 25, 50, 100]

    const rangeDate = ref('')

    const { pickerOptions } = PickerOptions(request.value)
    const report_wrapper = ref(null)


    const filter_included_fields = ['device', 'container', 'time', 'location', 'owner', 'contract'];
    const report_fields = [
      {
        key: 'id',
        label: 'id',
        sortable: true
      },
      {
        key: 'owner',
        label: 'owner',
        sortable: true
      },
      {
        key: 'contract',
        label:'contract',
        sortable: true
      },
      {
        key: 'device',
        label: 'device',
        sortable: true
      },

      {
        key: 'container',
        label: 'container',
        sortable: true
      },
      {
        key: 'tag',
        label: 'tag',
        sortable: false
      },
      {
        key: 'time',
        label: 'time',
        sortable: true
      },
      {
        key: 'location',
        label: 'location',
        sortable: false
      },
      

    ]







    return {
      report_data, report_fields, filter_included_fields, total, from, to, rangeDate,
      tableRef,
      getReport,
      perPageOptions,


      getReportForPdf,
      pickerOptions,
      report_wrapper,

      request,
      loading,
      errors,
      devices,
      owners,
      contracts,
      containers,
      reFilterDevices,
      divicesFilterd,
      merageFilterWithRequest,
      sortData,
      dataTableloading

    }


  },



}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
